import React from 'react';
import 'antd/dist/antd.css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Avatar,
  Button,
  Layout,
  PageHeader,
  Row,
  Col,
  Typography,
  Card,
  Modal,
  Progress,
  message,
  Checkbox,
  Switch,
} from 'antd';
import {
  BulbOutlined,
  ProjectOutlined,
  CheckCircleOutlined,
  QuestionCircleOutlined,
  PieChartOutlined,
} from '@ant-design/icons';

import {
  updateSkill,
  updateWorkspace,
  getUserOnboarding,
  updateUserOnboarding,
  getConfluenceChannelConfigs,
  getSkillUser,
  getWorkspaceAdmins,
} from '../skills_action';

import { productDetails } from '../../../utils/productDetails';
import ModalContent from './ModalContent';
import axios from 'axios';

const { Content } = Layout;

const { Text } = Typography;

class GettingStarted extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkinSkill: false,
      jiraSkill: false,
      wikiSkill: false,
      loading: true,
      project: false,
      helpdesk: false,
      report: false,
      userOnboardingData: null,
    };
  }

  componentDidMount() {
    const { skills } = this.props;
    this.props.getWorkspaceAdmins(this.props.match.params.wId);
    if (skills.length > 0 && this.props.botuser && this.props.botuser._id) {
      this.setStateValues();
      // this.setCheckinStateValues();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { skills } = this.props;

    if (
      (skills !== prevProps.skills ||
        this.props.botuser !== prevProps.botuser) &&
      skills.length > 0 &&
      this.props.botuser &&
      this.props.botuser._id
    ) {
      this.setStateValues();
      // this.setCheckinStateValues();
    }
  }

  checkinPercentage = () => {
    const { userOnboardingData } = this.state;

    let checkinPercentage = 0;

    if (userOnboardingData && userOnboardingData.checkins) {
      const {
        setup_standup_checkin,
        submit_standup_answer,
        integrate_with_jira,
        unfurl_jira_issue_mentions,
      } = userOnboardingData.checkins;
      if (
        setup_standup_checkin &&
        submit_standup_answer &&
        integrate_with_jira &&
        unfurl_jira_issue_mentions
      )
        checkinPercentage = 100;
      else {
        if (setup_standup_checkin) checkinPercentage += 25;
        if (submit_standup_answer) checkinPercentage += 25;
        if (integrate_with_jira) checkinPercentage += 25;
        if (unfurl_jira_issue_mentions) checkinPercentage += 25;
      }
    }

    return checkinPercentage;
  };

  projectPercentage = () => {
    const { userOnboardingData } = this.state;

    let projectPercentage = 0;
    if (userOnboardingData && userOnboardingData.projects) {
      const {
        setup_demo_project_channel,
        issue_card_customization,
        customize_personal_notification,
        customize_creation_form,
        commands,
        emoji_actions,
      } = userOnboardingData.projects;

      if (
        this.checkWorkspaceLevelStepStatus({
          product: 'projects',
          stepKey: 'connect_to_jira',
        }) &&
        setup_demo_project_channel &&
        issue_card_customization &&
        customize_personal_notification &&
        customize_creation_form &&
        commands &&
        emoji_actions
      ) {
        projectPercentage = 100;
      } else {
        if (
          this.checkWorkspaceLevelStepStatus({
            product: 'projects',
            stepKey: 'connect_to_jira',
          })
        )
          projectPercentage += 15;
        if (setup_demo_project_channel) projectPercentage += 15;
        if (issue_card_customization) projectPercentage += 15;
        if (customize_personal_notification) projectPercentage += 15;
        if (customize_creation_form) projectPercentage += 15;
        if (commands) projectPercentage += 15;
        if (emoji_actions) projectPercentage += 15;
      }
    } else {
      if (
        this.checkWorkspaceLevelStepStatus({
          product: 'projects',
          stepKey: 'connect_to_jira',
        })
      )
        projectPercentage += 15;
    }

    return projectPercentage;
  };

  helpdeskPercentage = () => {
    const { userOnboardingData } = this.state;

    let helpdeskPercentage = 0;
    if (userOnboardingData && userOnboardingData.helpdesk) {
      const {
        setup_demo_channels,
        customize_support_channel,
        customize_agent_channel,
        manage_approvals,
        manage_private_requests,
      } = userOnboardingData.helpdesk;

      if (
        this.checkWorkspaceLevelStepStatus({
          product: 'helpdesk',
          stepKey: 'connect_to_jsm',
        }) &&
        setup_demo_channels &&
        customize_support_channel &&
        customize_agent_channel &&
        manage_approvals &&
        manage_private_requests
      ) {
        helpdeskPercentage = 100;
      } else {
        if (
          this.checkWorkspaceLevelStepStatus({
            product: 'helpdesk',
            stepKey: 'connect_to_jsm',
          })
        )
          helpdeskPercentage += 17;
        if (setup_demo_channels) helpdeskPercentage += 17;
        if (customize_support_channel) helpdeskPercentage += 17;
        if (customize_agent_channel) helpdeskPercentage += 16;
        if (manage_approvals) helpdeskPercentage += 16;
        if (manage_private_requests) helpdeskPercentage += 16;
      }
    } else {
      if (
        this.checkWorkspaceLevelStepStatus({
          product: 'helpdesk',
          stepKey: 'connect_to_jsm',
        })
      )
        helpdeskPercentage += 16.5;
    }
    return helpdeskPercentage;
    // this.setState({ helpdeskPercentage });
  };

  wikiPercentage = () => {
    const { userOnboardingData } = this.state;

    let wikiPercentage = 0;

    if (userOnboardingData && userOnboardingData.wiki) {
      const {
        setup_demo_wiki_channel,
        add_to_confluence,
        search_an_article_privately,
      } = userOnboardingData.wiki;

      if (
        this.checkWorkspaceLevelStepStatus({
          stepKey: 'connect_to_confluence',
          product: 'wiki',
        }) &&
        setup_demo_wiki_channel &&
        add_to_confluence &&
        search_an_article_privately
      )
        wikiPercentage = 100;
      else {
        if (
          this.checkWorkspaceLevelStepStatus({
            stepKey: 'connect_to_confluence',
            product: 'wiki',
          })
        )
          wikiPercentage += 25;
        if (setup_demo_wiki_channel) wikiPercentage += 25;
        if (add_to_confluence) wikiPercentage += 25;
        if (search_an_article_privately) wikiPercentage += 25;
      }
    } else {
      if (
        this.checkWorkspaceLevelStepStatus({
          stepKey: 'connect_to_confluence',
          product: 'wiki',
        })
      )
        wikiPercentage += 25;
    }

    return wikiPercentage;
  };

  reportPercentage = () => {
    const { userOnboardingData } = this.state;

    let reportPercentage = 0;
    if (userOnboardingData && userOnboardingData.reports) {
      const {
        setup_chart_report,
        setup_issue_list_report,
        setup_custom_report,
        setup_personal_report,
      } = userOnboardingData.reports;

      if (
        this.checkWorkspaceLevelStepStatus({
          product: 'reports',
          stepKey: 'connect_to_jira',
        }) &&
        setup_chart_report &&
        setup_issue_list_report &&
        setup_custom_report &&
        setup_personal_report
      )
        reportPercentage = 100;
      else {
        if (
          this.checkWorkspaceLevelStepStatus({
            product: 'reports',
            stepKey: 'connect_to_jira',
          })
        )
          reportPercentage += 20;
        if (setup_chart_report) reportPercentage += 20;
        if (setup_issue_list_report) reportPercentage += 20;
        if (setup_custom_report) reportPercentage += 20;
        if (setup_personal_report) reportPercentage += 20;
      }
    } else {
      if (
        this.checkWorkspaceLevelStepStatus({
          product: 'reports',
          stepKey: 'connect_to_jira',
        })
      )
        reportPercentage += 20;
    }
    return reportPercentage;
  };

  setStateValues = () => {
    const { skills } = this.props;

    getUserOnboarding({
      wId: this.props.match.params.wId,
      user_id: this.props.botuser._id,
    }).then((res) => {
      if (res.data.success)
        this.setState({
          userOnboardingData: res.data.userOnboardingData,
          loading: false,
        });
    });
    // var UserId = localStorage.trooprUserId;

    const wiki = skills.find((skill) => skill.key === 'wiki');
    const jiraSkill = skills.find((skill) => skill.key === 'jira');

    const jiraProject = jiraSkill.skill_metadata.sub_skills.find(
      (sub) => sub.key === 'jira_software'
    );
    const jiraReport = jiraSkill.skill_metadata.sub_skills.find(
      (sub) => sub.key === 'jira_reports'
    );
    const jiraHelpdesk = jiraSkill.skill_metadata.sub_skills.find(
      (sub) => sub.key === 'jira_service_desk'
    );
    const checkinSkill = skills.find((skill) => skill.key === 'standups');

    this.setState({
      jiraSkill: jiraSkill,
      wikiSkill: wiki,
      project: jiraProject,
      helpdesk: jiraHelpdesk,
      report: jiraReport,
      checkinSkill: checkinSkill,
    });
  };

  handleActivation = async ({ product, checked }) => {
    const { checkinSkill, jiraSkill, wikiSkill, project, helpdesk, report } =
      this.state;
    const { updateSkill, updateWorkspace, isWorkspaceAdmin } = this.props;

    const projectsDisabled = project && project.disabled;
    const helpdeskDisabled = helpdesk && helpdesk.disabled;
    const reportDisabled = report && report.disabled;
    const wikiDisabled =
      wikiSkill &&
      wikiSkill.skill_metadata &&
      wikiSkill.skill_metadata.disabled;
    const checkinDisabled =
      checkinSkill &&
      checkinSkill.skill_metadata &&
      checkinSkill.skill_metadata.disabled;

    let enabledProductsCount = 0;

    if (!checked) {
      if (!projectsDisabled) enabledProductsCount++;
      if (helpdesk && !helpdeskDisabled) enabledProductsCount++;
      if (!reportDisabled) enabledProductsCount++;
      if (wikiSkill && wikiSkill.skill_metadata && !wikiDisabled)
        enabledProductsCount++;
      if (!checkinDisabled) enabledProductsCount++;

      if (enabledProductsCount === 1) {
        message.error('Atleast one product must be enabled');
        return;
      }
    }

    if (!isWorkspaceAdmin) {
      return message.warning(this.getErrorMessage());
    }

    let title = 'Are you sure?';
    let content = '';
    let skill = null;
    let subSkill = null;

    if (
      product === 'helpdesk' ||
      product === 'projects' ||
      product === 'reports'
    ) {
      skill = jiraSkill;
      subSkill =
        product === 'helpdesk'
          ? helpdesk
          : product === 'projects'
          ? project
          : report;
    } else if (product === 'checkins') skill = checkinSkill;
    else if (product === 'wiki') skill = wikiSkill;

    if (checked) {
      if (product === 'checkins') {
        Modal.confirm({
          title: `${checked ? 'Enable' : 'Disable'} Check-in`,
          content: `This action will ${
            checked ? 'enable' : 'disable'
          } Check-ins.`,
          okText: 'Proceed',
          onOk: () => {
            this.onFeatureT(skill.skill_metadata, subSkill);
          },
        });
      } else if (
        product === 'projects' ||
        product === 'helpdesk' ||
        product === 'reports'
      ) {
        Modal.confirm({
          title: `${checked ? 'Enable' : 'Disable'} ${
            product === 'helpdesk'
              ? 'Helpdesk'
              : product === 'projects'
              ? 'Projects'
              : 'Reports'
          }`,
          content:
            product === 'projects'
              ? `This action will ${checked ? 'enable' : 'disable'} Projects.`
              : `This action will ${checked ? 'enable' : 'disable'} ${
                  jiraSkill && jiraSkill.skill_metadata.disabled
                    ? 'Projects, '
                    : ''
                } ${product === 'helpdesk' ? 'HelpDesk' : 'Reports'}.`,
          okText: 'Proceed',
          onOk: () => {
            this.onFeatureT(skill.skill_metadata, subSkill);
          },
        });
      } else if (product === 'wiki') {
        Modal.confirm({
          title: `${checked ? 'Enable' : 'Disable'} Confluence`,
          content: `This action will ${checked ? 'enable' : 'disable'} Wiki.`,
          okText: 'Proceed',
          onOk: () => {
            this.onFeatureT(skill.skill_metadata, subSkill);
          },
        });
      }
    } else {
      if (product === 'projects') {
        content = (
          <div>
            This action will disable notifications for everyone in this
            workspace. <br /> <br />
            All notification subscriptions will be disabled. <br />
            <br />
            This action is irreversible. Are you sure?
          </div>
        );
      } else if (product === 'helpdesk') {
        content = (
          <div>
            This action will disable HelpDesk for everyone in this workspace.{' '}
            <br /> <br />
            This action is irreversible. Are you sure?
          </div>
        );
      } else if (product === 'reports') {
        let res = await axios.post(
          `/bot/api/w/${this.props.match.params.wId}/workspace/disableallWorkspaceJiraReports?getCount=true`
        );
        if (res.data.success) {
          content = (
            <div>
              This action will disable Jira reports for everyone in this
              workspace. <br /> <br />
              {res.data.personalReportsCount} personal reports will be disabled.{' '}
              <br />
              {res.data.channelReportsCount} channel reports will be disabled.{' '}
              <br />
              <br />
              This action is irreversible. Are you sure?
            </div>
          );
        } else {
          content = (
            <div>
              This action will disable Jira reports for everyone in this
              workspace. <br /> <br />
              All notification subscriptions will be disabled. <br />
              <br />
              This action is irreversible. Are you sure?
            </div>
          );
        }
      } else if (product === 'checkins') {
        let res = await axios.post(
          `/api/w/${this.props.match.params.wId}/disableAllTeamsyncsinWorkspace?getCount=true`
        );
        content = res.data.success ? (
          <div>
            This action will disable Check-ins for everyone in this workspace.{' '}
            <br />
            <br />
            {res.data.activeCheckinsCount} Check-ins will be disabled. <br />
            <br />
            This action is irreversible. Are you sure?
          </div>
        ) : (
          <div>
            This action will disable Check-ins for everyone in this workspace.{' '}
            <br />
            <br />
            This action is irreversible. Are you sure?
          </div>
        );
      } else if (product === 'wiki') {
        let res = await this.props.getConfluenceChannelConfigs(
          this.props.match.params.wId,
          true,
          true
        );

        content = res.data.success ? (
          <div>
            This action will disable Wiki (Confluence) Bot and its
            configurations. <br />
            <br />
            {res.data.configs} channel reports will be disabled. <br />
            <br />
            This action is irreversible. Are you sure?
          </div>
        ) : (
          <div>
            This action will disable Wiki (Confluence) Bot and its
            configurations. <br />
            <br />
            This action is irreversible. Are you sure?
          </div>
        );
      }

      Modal.confirm({
        title: title,
        content: content,
        okText: 'Yes',
        okType: 'primary',
        onOk: () => this.onFeatureT(skill.skill_metadata, subSkill),
      });
    }
  };

  onFeatureT = (skill, subSkill) => {
    let data = {};

    if (subSkill) {
      let temp = [...skill.sub_skills];
      temp = temp.map((s) => {
        if (s.key === subSkill.key) {
          s.disabled = !subSkill.disabled;
          return s;
        } else return s;
      });
      data.sub_skills = [...temp];
    } else {
      data.disabled = !skill.disabled;
    }
    const { defaultSkill, user_now, updateSkill, skills, updateWorkspace } =
      this.props;

    this.props
      .updateSkill(
        skill._id,
        this.props.match.params.wId,
        data,
        /* cuurentSkill */ false,
        /* don't update current skill */ true
      )
      .then((res) => {
        if (res.data.success) {
          let new_skill = res.data.skill;
          let name = skill.name;

          if (subSkill) {
            if (
              name === 'Jira' &&
              subSkill.key === 'jira_reports' &&
              subSkill.disabled
            ) {
              axios
                .post(
                  `/bot/api/w/${this.props.match.params.wId}/workspace/disableallWorkspaceJiraReports`
                )
                .then((res) => {
                  if (res.data.success)
                    message.success(
                      `${res.data.disabledReports} Report(s) disabled successfully`
                    );
                });
            }
          } else if (name == 'Check-ins' || name == 'Standups') {
            updateWorkspace(this.props.match.params.wId, '', {
              disableCheckins: new_skill.disabled,
            });
            if (new_skill.disabled) {
              let checkinData = {
                edited_by: user_now._id,
                edited_by_name:
                  user_now.displayName ||
                  user_now.name ||
                  user_now.user_name ||
                  '',
              };
              axios
                .post(
                  `/api/w/${this.props.match.params.wId}/disableAllTeamsyncsinWorkspace`,
                  checkinData
                )
                .then((res) => {});
            }
          } else if (name == 'Troopr Projects' || name == 'Troopr') {
            updateWorkspace(this.props.match.params.wId, '', {
              showSquads: !new_skill.disabled,
            });
          }
        } else if (res.data.error && res.data.error === 'not_a_workspace_admin')
          message.error(
            'Contact one of the workspace admins to enable/disable products'
          );
      });
  };

  getErrorMessage = () => {
    let adminNames =
      'Contact one of the workspace admins to enable/disable this product: ';

    const allWorkspaceAdmins = this.props.admins;

    if (allWorkspaceAdmins.length > 3) {
      adminNames = adminNames + ` and ${allWorkspaceAdmins.length - 3} others`;
    }

    return adminNames;
  };

  handleStepDone = ({ product, stepKey }) => {
    this.handleCheckBoxChange({
      checked: true,
      step: { key: stepKey },
      product,
    });
  };

  handleCheckBoxChange = ({ step, product, checked }) => {
    const { jiraSkill, wikiSkill, userOnboardingData } = this.state;

    // if (!this.checkProductActivation(product)) return;

    if (
      product === 'helpdesk' ||
      product === 'projects' ||
      product === 'reports'
    ) {
      if (
        jiraSkill &&
        jiraSkill.skill_metadata &&
        !jiraSkill.skill_metadata.linked
      ) {
        message.error('Please connect to Jira loreum ipsum loreum ipsum');
        return;
      }
    } else if (product === 'wiki') {
      if (
        wikiSkill &&
        wikiSkill.skill_metadata &&
        !wikiSkill.skill_metadata.linked
      ) {
        message.error('Please connect to Confluence loreum ipsum loreum ipsum');
        return;
      }
    }

    const data = {
      [product]:
        userOnboardingData && userOnboardingData[product]
          ? { ...userOnboardingData[product], [step.key]: checked }
          : { [step.key]: checked },
    };

    updateUserOnboarding({
      wId: this.props.match.params.wId,
      user_id: this.props.botuser._id,
      data,
    }).then((res) => {
      if (res.data.success && res.data.userOnboardingData) {
        this.setState({ userOnboardingData: res.data.userOnboardingData });
        if (
          (product === 'helpdesk' && this.helpdeskPercentage() === 100) ||
          (product === 'projects' && this.projectPercentage() === 100) ||
          (product === 'reports' && this.reportPercentage() === 100) ||
          (product === 'wiki' && this.wikiPercentage() === 100) ||
          (product === 'checkins' && this.checkinPercentage() === 100)
        )
          message.success({
            content: '🥳 Congratulations on completing the onboarding!',
            icon: <></>,
          });
      }
    });
  };

  checkWorkspaceLevelStepStatus = ({ product, stepKey }) => {
    const { jiraSkill, wikiSkill, checkinSkill } = this.state;
    let status = false;

    const isJiraConnected =
      jiraSkill && jiraSkill.skill_metadata && jiraSkill.skill_metadata.linked;
    const isWikiConnected =
      wikiSkill && wikiSkill.skill_metadata && wikiSkill.skill_metadata.linked;

    if (product === 'helpdesk' && stepKey === 'connect_to_jsm')
      status = isJiraConnected;
    else if (product === 'reports' && stepKey === 'connect_to_jira')
      status = isJiraConnected;
    else if (product === 'projects' && stepKey === 'connect_to_jira')
      status = isJiraConnected;
    else if (product === 'wiki' && stepKey === 'connect_to_confluence')
      status = isWikiConnected;

    return status;
  };

  getCard = ({ stepsData, product, disabled }) => {
    const {
      loading,
      userOnboardingData,
      project,
      helpdesk,
      report,
      jiraSkill,
      wikiSkill,
    } = this.state;

    const isJiraConnected =
      jiraSkill && jiraSkill.skill_metadata && jiraSkill.skill_metadata.linked;
    const isWikiConnected =
      wikiSkill && wikiSkill.skill_metadata && wikiSkill.skill_metadata.linked;
    const meta = {
      checkins: {
        title: productDetails.checkIn.name,
        icon: <CheckCircleOutlined />,
        percent: this.checkinPercentage(),
        disabled:
          this.state.checkinSkill &&
          this.state.checkinSkill.skill_metadata &&
          this.state.checkinSkill.skill_metadata.disabled,
        description: productDetails.checkIn.description,
      },
      projects: {
        title: productDetails.project.name,
        icon: <ProjectOutlined />,
        percent: this.projectPercentage(),
        disabled: project && project.disabled,
        description: productDetails.project.description,
      },
      helpdesk: {
        title: productDetails.helpDesk.name,
        icon: <QuestionCircleOutlined />,
        percent: this.helpdeskPercentage(),
        disabled: helpdesk && helpdesk.disabled,
        description: productDetails.helpDesk.description,
      },
      reports: {
        title: productDetails.report.name,
        icon: <PieChartOutlined />,
        percent: this.reportPercentage(),
        disabled: report && report.disabled,
        description: productDetails.report.description,
      },
      wiki: {
        title: productDetails.wiki.name,
        icon: <BulbOutlined />,
        percent: this.wikiPercentage(),
        disabled:
          this.state.wikiSkill &&
          this.state.wikiSkill.skill_metadata &&
          this.state.wikiSkill.skill_metadata.disabled,
        description: productDetails.wiki.description,
      },
    };

    return (
      <Card
        title={
          <span>
            <Avatar
              style={{
                backgroundColor: '#402e96',
                margin: '0px 8px 0px 0px',
              }}
              icon={meta[product].icon}
            />
            {meta[product].title}
          </span>
        }
        extra={
          <Switch
            onClick={(checked) => this.handleActivation({ product, checked })}
            checked={!meta[product].disabled}
          />
        }
        style={{ minWidth: 300, height: '100%' }}
        bodyStyle={{ height: '65%' }}
        loading={loading}
      >
        {disabled ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
            }}
          >
            <Text type='secondary'>{meta[product].description}</Text> <br />
            <Button
              type='primary'
              onClick={() => this.handleActivation({ product, checked: true })}
            >
              Enable {meta[product].title}
            </Button>
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Text style={{ margin: '0px 0px 8px 0px' }} type='secondary'>
              {meta[product].description}
            </Text>
            <Progress
              type='circle'
              percent={meta[product].percent}
              // width={80}
              style={{ margin: 8 }}
            />
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'baseline',
              }}
            >
              {stepsData.map((step) => {
                return (
                  <div>
                    <Checkbox
                      onChange={(e) =>
                        this.handleCheckBoxChange({
                          checked: e.target.checked,
                          step,
                          product,
                        })
                      }
                      checked={
                        step.action_type === 'workspace'
                          ? this.checkWorkspaceLevelStepStatus({
                              stepKey: step.key,
                              product,
                            })
                          : userOnboardingData &&
                            userOnboardingData[product] &&
                            userOnboardingData[product][step.key]
                      }
                      disabled={
                        step.action_type === 'workspace'
                          ? true
                          : product === 'helpdesk' ||
                            product === 'projects' ||
                            product === 'reports'
                          ? isJiraConnected
                            ? false
                            : true
                          : product === 'wiki'
                          ? isWikiConnected
                            ? false
                            : true
                          : false
                      }
                    />
                    <Button
                      type={'link'}
                      size='small'
                      style={{ margin: '8px 0px 4px 7px' }}
                      onClick={() => {
                        this.handleStepClick({ step, product });
                      }}
                      disabled={
                        step.action_type === 'workspace'
                          ? false
                          : product === 'helpdesk' ||
                            product === 'projects' ||
                            product === 'reports'
                          ? isJiraConnected
                            ? false
                            : true
                          : product === 'wiki'
                          ? isWikiConnected
                            ? false
                            : true
                          : false
                      }
                    >
                      {step.label}
                    </Button>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </Card>
    );
  };

  handleStepClick = async ({ step, product }) => {
    const { jiraSkill, wikiSkill } = this.state;

    // if (!this.checkProductActivation(product)) return;

    if (step.openModal) {
      // if (
      //   product === 'helpdesk' ||
      //   product === 'projects' ||
      //   product === 'reports'
      // ) {
      //   if (
      //     jiraSkill &&
      //     jiraSkill.skill_metadata &&
      //     !jiraSkill.skill_metadata.linked
      //   ) {
      //     message.error('Please connect to Jira loreum ipsum loreum ipsum');
      //     return;
      //   }
      // } else if (product === 'wiki') {
      //   if (
      //     wikiSkill &&
      //     wikiSkill.skill_metadata &&
      //     wikiSkill.skill_metadata.disabled
      //   ) {
      //     message.error('Please enable product loreum ipsum loreum ipsum');
      //     return;
      //   }
      //   if (
      //     wikiSkill &&
      //     wikiSkill.skill_metadata &&
      //     !wikiSkill.skill_metadata.linked
      //   ) {
      //     message.error(
      //       'Please connect to Confluence loreum ipsum loreum ipsum'
      //     );
      //     return;
      //   }
      // }

      let personalConnected = false;

      if (
        (product === 'helpdesk' && step.key === 'setup_demo_channels') ||
        (product === 'projects' && step.key === 'setup_demo_project_channel')
      ) {
        await this.props
          .getSkillUser(
            this.props.match.params.wId,
            jiraSkill.skill_metadata._id
          )
          .then((res) => {
            if (res.data.success) {
              if (
                res.data.skillUser &&
                res.data.skillUser.token_obj &&
                res.data.skillUser.token_obj.access_token
              ) {
                personalConnected = true;
              }
            }
          });

        if (!personalConnected) {
          message.error({
            content: (
              <>
                Verify your personal Jira account to setup demo channels.{' '}
                <a
                  onClick={() => {
                    message.destroy('personal_not_connected_error_message');
                    this.props.history.push(
                      `/${this.props.match.params.wId}/skills/${
                        jiraSkill.skill_metadata._id
                      }/${
                        product === 'helpdesk'
                          ? 'jira_service_desk'
                          : 'jira_software'
                      }?view=personal_preferences`
                    );
                  }}
                >
                  Click here
                </a>{' '}
                to verify your account.
              </>
            ),
            key: 'personal_not_connected_error_message',
          });
          return;
        }
      }

      let url = `/${this.props.match.params.wId}/getting_started?product=${product}&step=${step.key}`;
      if (
        (product === 'helpdesk' && step.key === 'setup_demo_channels') ||
        (product === 'projects' && step.key === 'setup_demo_project_channel') ||
        (product === 'wiki' && step.key === 'setup_demo_wiki_channel')
      ) {
        url += `&page=1`;
      }
      this.props.history.push(url);
    } else if (product === 'helpdesk' && step.key === 'connect_to_jsm')
      this.props.history.push(
        `/${this.props.match.params.wId}/skills/${jiraSkill.skill_metadata._id}/jira_service_desk?view=connection`
      );
    else if (product === 'projects' && step.key === 'connect_to_jira')
      this.props.history.push(
        `/${this.props.match.params.wId}/skills/${jiraSkill.skill_metadata._id}/jira_software?view=connection`
      );
    else if (product === 'reports' && step.key === 'connect_to_jira')
      this.props.history.push(
        `/${this.props.match.params.wId}/skills/${jiraSkill.skill_metadata._id}/jira_reports?view=connection`
      );
    else if (product === 'wiki' && step.key === 'connect_to_confluence')
      this.props.history.push(
        `/${this.props.match.params.wId}/skills/${wikiSkill.skill_metadata._id}?view=connection`
      );
  };

  // checkProductActivation = (product) => {
  //   const { jiraSkill, wikiSkill, helpdesk, project, report, checkinSkill } =
  //     this.state;

  //   if (product === 'helpdesk' && helpdesk && helpdesk.disabled) {
  //     message.error('Please enable product loreum ipsum loreum ipsum');
  //     return false;
  //   }
  //   if (product === 'projects' && project && project.disabled) {
  //     message.error('Please enable product loreum ipsum loreum ipsum');
  //     return false;
  //   }
  //   if (product === 'reports' && report && report.disabled) {
  //     message.error('Please enable product loreum ipsum loreum ipsum');
  //     return false;
  //   }
  //   if (
  //     product === 'wiki' &&
  //     wikiSkill &&
  //     wikiSkill.skill_metadata &&
  //     wikiSkill.skill_metadata.disabled
  //   ) {
  //     message.error('Please enable product loreum ipsum loreum ipsum');
  //     return false;
  //   }
  //   if (
  //     product === 'checkins' &&
  //     checkinSkill &&
  //     checkinSkill.skill_metadata &&
  //     checkinSkill.skill_metadata.disabled
  //   ) {
  //     message.error('Please enable product loreum ipsum loreum ipsum');
  //     return false;
  //   }

  //   return true;
  // };

  render() {
    const { wikiSkill, helpdesk, project, report, checkinSkill } = this.state;

    const contentStyle = {
      margin: 0,
      height: '160px',
      color: '#fff',
      lineHeight: '160px',
      textAlign: 'center',
      background: '#364d79',
    };
    return (
      <>
        <Layout /* style={{ marginLeft: 250 }} */>
          <Content
            style={{
              height: '100vh',
              padding: '10px 16px 32px 24px',
              overflow: 'auto',
            }}
          >
            <PageHeader
              title='Quick ways to get started'
              style={{ paddingLeft: 0 }}
            />
            <Row gutter={[16, 16]}>
              {helpdesk && (
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  lg={{ span: 12 }}
                  xxl={{ span: 8 }}
                >
                  {this.getCard({
                    product: 'helpdesk',
                    disabled: helpdesk && helpdesk.disabled,
                    stepsData: [
                      {
                        label: 'Step 1 : Connect to JSM',
                        key: 'connect_to_jsm',
                        action_type: 'workspace',
                      },
                      {
                        label: 'Step 2 : Setup demo channels',
                        key: 'setup_demo_channels',
                        openModal: true,
                      },
                      {
                        label: 'Step 3 : Customize support channel',
                        key: 'customize_support_channel',
                        openModal: true,
                        required_step: 'setup_demo_channels',
                      },
                      {
                        label: 'Step 4 : Customize agent channel',
                        key: 'customize_agent_channel',
                        openModal: true,
                        required_step: 'setup_demo_channels',
                      },
                      {
                        label: 'Step 5 : Manage private requests',
                        key: 'manage_private_requests',
                        openModal: true,
                        required_step: 'setup_demo_channels',
                      },
                      {
                        label: 'Step 6 : Manage approvals',
                        key: 'manage_approvals',
                        openModal: true,
                        required_step: 'setup_demo_channels',
                      },
                    ],
                  })}
                </Col>
              )}
              {wikiSkill && wikiSkill.skill_metadata && (
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  lg={{ span: 12 }}
                  xxl={{ span: 8 }}
                >
                  {this.getCard({
                    product: 'wiki',
                    disabled:
                      wikiSkill &&
                      wikiSkill.skill_metadata &&
                      wikiSkill.skill_metadata.disabled,
                    stepsData: [
                      {
                        label: 'Step 1 : Connect Confluence',
                        key: 'connect_to_confluence',
                        action_type: 'workspace',
                      },
                      {
                        label: 'Step 2 : Setup demo wiki channel',
                        key: 'setup_demo_wiki_channel',
                        openModal: true,
                      },
                      {
                        label: 'Step 3 : Add to Confluence',
                        key: 'add_to_confluence',
                        openModal: true,
                      },
                      {
                        label: 'Step 4 : Search an article privately',
                        key: 'search_an_article_privately',
                        openModal: true,
                      },
                    ],
                  })}
                </Col>
              )}
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                lg={{ span: 12 }}
                xxl={{ span: 8 }}
              >
                {this.getCard({
                  product: 'reports',
                  disabled: report && report.disabled,
                  stepsData: [
                    {
                      label: 'Step 1 : Connect to Jira',
                      key: 'connect_to_jira',
                      action_type: 'workspace',
                    },
                    {
                      label: 'Step 2 : Setup chart report',
                      key: 'setup_chart_report',
                      openModal: true,
                    },
                    {
                      label: 'Step 3 : Setup issue list report',
                      key: 'setup_issue_list_report',
                      openModal: true,
                    },
                    {
                      label: 'Step 4 : Setup custom report',
                      key: 'setup_custom_report',
                      openModal: true,
                    },
                    {
                      label: 'Step 5 : Setup personal report',
                      key: 'setup_personal_report',
                      openModal: true,
                    },
                  ],
                })}
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                lg={{ span: 12 }}
                xxl={{ span: 8 }}
              >
                {this.getCard({
                  product: 'projects',
                  disabled: project && project.disabled,
                  stepsData: [
                    {
                      label: 'Step 1 : Connect to Jira',
                      key: 'connect_to_jira',
                      action_type: 'workspace',
                    },
                    {
                      label: 'Step 2 : Setup demo project channel',
                      key: 'setup_demo_project_channel',
                      openModal: true,
                    },
                    {
                      label: 'Step 3 : Issue card customization',
                      key: 'issue_card_customization',
                      openModal: true,
                    },
                    {
                      label: 'Step 4 : Customize personal notifications',
                      key: 'customize_personal_notification',
                      openModal: true,
                    },
                    {
                      label: 'Step 5 : Customize creation form',
                      key: 'customize_creation_form',
                      openModal: true,
                    },
                    {
                      label: 'Step 6 : Commands',
                      key: 'commands',
                      openModal: true,
                    },
                    {
                      label: 'Step 7 : Emoji actions',
                      key: 'emoji_actions',
                      openModal: true,
                    },
                  ],
                })}
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                lg={{ span: 12 }}
                xxl={{ span: 8 }}
              >
                {this.getCard({
                  product: 'checkins',
                  disabled:
                    checkinSkill &&
                    checkinSkill.skill_metadata &&
                    checkinSkill.skill_metadata.disabled,
                  stepsData: [
                    {
                      label: 'Step 1 : Setup standup check-in',
                      key: 'setup_standup_checkin',
                      openModal: true,
                    },
                    {
                      label: 'Step 2 : Submit standup answer',
                      key: 'submit_standup_answer',
                      openModal: true,
                    },
                    {
                      label: 'Step 3 : Integrate with Jira',
                      key: 'integrate_with_jira',
                      openModal: true,
                    },
                    {
                      label: 'Step 4 : Unfurl Jira issue mentions',
                      key: 'unfurl_jira_issue_mentions',
                      openModal: true,
                    },
                  ],
                })}
              </Col>
            </Row>
          </Content>

          {/* {newStandupModalVisible && (
            <CreateTeamsyncModal
              newStandupModalVisible={newStandupModalVisible}
              modalToggle={this.toggleNewStandupModal}
              // https://stackoverflow.com/questions/37949981/call-child-method-from-parent
              setClick={(click) => (this.clickChild = click)}

              //whenever you add something here check in allstandups,standupReport,sidenavbar files too
            />
          )} */}

          <ModalContent
            handleStepDone={({ product, stepKey }) =>
              this.handleStepDone({ product, stepKey })
            }
          />
        </Layout>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  skills: state.skills.skills,
  isWorkspaceAdmin: state.common_reducer.isAdmin,
  admins: state.skills.wAdmins,
  user_now: state.common_reducer.user,
  team: state.skills.team,
  botuser: state.common_reducer.tpuser,
});

export default withRouter(
  connect(mapStateToProps, {
    updateSkill,
    updateWorkspace,
    getConfluenceChannelConfigs,
    getSkillUser,
    getWorkspaceAdmins,
  })(GettingStarted)
);
